<style lang="scss">
  @use "../../components/shared/tab-body.scss";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .data-refresh {
    overflow: auto;
    height: 100%;

    .refresh-toggle {
      margin-top: utils.in_rem(18px);
      margin-bottom: utils.in_rem(2px);
    }

    .contact-data-toggle {
      margin-top: utils.in_rem(18px);
      margin-bottom: utils.in_rem(2px);
      margin-left: utils.in_rem(16px);
    }
  }

  .refresh-content {
    margin-top: utils.in_rem(16px);
  }
</style>

<script>
  import DataRefreshPromo from "../../../../elements/DataRefreshPromo/DataRefreshPromo.svelte";
  import Description from "../../components/shared/Description.svelte";
  import ContactDataToggle from "./components/ContactDataToggle.svelte";
  import DataRefreshContent from "./components/DataRefreshContent.svelte";
  import DataRefreshInit from "./components/DataRefreshInit.svelte";
  import RefreshToggle from "./components/RefreshToggle.svelte";
  // Stores
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import {
    activeProviderConfigStore,
    currentProviderStore,
    integrationStore,
  } from "../../stores";

  $: providerTitle = $integrationStore.getProviderTitle();
  $: provider = $integrationStore.getProviderName();

  $: {
    $currentProviderStore = provider;
  }

  let isDataRefreshEnabled;
  $: isDataRefreshEnabled = $integrationStore.getValue(
    "enabled",
    "dataRefresh"
  );

  $: description = {
    title: "Data Refresh",
    description: `When enabled SourceWhale will automatically update and verify key contact information in SourceWhale and ${providerTitle}. This includes fields like name, company, role, and more. Any Protected field specified in Sync Settings will not be overwritten.`,
    learnMoreLink:
      "https://help.sourcewhale.app/en/articles/9685028-sourcewhale-data-refresh",
  };

  // Filter out any sync kinds that include " & " in their name for data refresh
  $: syncTypes = ($activeProviderConfigStore?.syncKinds || []).filter(
    (type) => !type.includes(" & ")
  );

  $: contactTypeOptions = syncTypes.map((type) => ({
    val: type,
    key: type,
  }));
</script>

<DataRefreshInit {provider} />

{#if $userStore.dataRefresh}
  <div class="data-refresh tab-body">
    <Description {...description} />

    <div class="refresh-toggle">
      <RefreshToggle />
    </div>

    {#if isDataRefreshEnabled}
      <div class="contact-data-toggle">
        <ContactDataToggle {providerTitle} />
      </div>

      <DataRefreshContent {providerTitle} {contactTypeOptions} />
    {/if}
  </div>
{:else}
  <DataRefreshPromo />
{/if}
